import React from 'react';
import './TermsOfService.scss';
import accept_tems_path from '../../templates/Accept_Terms.pdf';
import { Button } from 'devextreme-react';
import notify from 'devextreme/ui/notify';

function TermsOfService({ onClosePopup }) {
  const terms = [
    {
      title: "Introduction",
      content: [
        "Welcome to the Britams Group Life Client and Brokers Portal. By accessing this portal, you agree to be bound by the following terms and conditions."
      ]
    },
    {
      title: "Account Registration",
      subSections: [
        {
          title: "Eligibility",
          content: "To use this portal, you must be at least 18 years old and have the legal capacity to enter into agreements."
        },
        {
          title: "Account Security",
          content: "You are responsible for maintaining the confidentiality of your account information and for all activities that occur under your account."
        }
      ]
    },
    {
      title: "Use of the Portal",
      subSections: [
        {
          title: "Permitted Use",
          content: "You may use the portal for lawful purposes and in accordance with these terms."
        },
        {
          title: "Prohibited Activities",
          content: "You agree not to use the portal for any illegal or unauthorized purpose."
        }
      ]
    },
    {
      title: "Intellectual Property",
      content: [
        "All content, trademarks, and data on this portal are the property of Britams or its licensors. You may not reproduce or redistribute any content without our prior written consent."
      ]
    },
    {
      title: "Termination",
      content: [
        "We reserve the right to terminate or suspend your access to the portal at our sole discretion, without notice, for conduct that we believe violates these terms or is harmful to other users of the portal."
      ]
    },
    {
      title: "Governing Law",
      content: [
        "These terms are governed by the laws of [Jurisdiction]. Any disputes arising out of or in connection with these terms will be subject to the exclusive jurisdiction of the courts of [Jurisdiction]."
      ]
    },
    {
      title: "Changes to Terms",
      content: [
        "We may revise these terms from time to time. The most current version will always be posted on our portal."
      ]
    }
  ];

  return (
    <div className="terms-container">
      {terms.map((section, index) => (
        <div key={index}>
          <div className="section-title">{section.title}</div>
          {section.content && section.content.map((paragraph, idx) => (
            <div key={idx} className="paragraph">{paragraph}</div>
          ))}
          {section.subSections && section.subSections.map((subSection, idx) => (
            <div key={idx}>
              <div className="sub-section-title">{subSection.title}</div>
              <div className="paragraph">{subSection.content}</div>
            </div>
          ))}
        </div>
      ))}
      <div className="important">
        Note: It is important to regularly review these terms to stay informed of any updates.
      </div>
      <div className="accept-button">
        <Button
          text="Accept & Download Terms of Service"
          icon='download'
          type="default"
          onClick={() => {
            fetch(accept_tems_path)
              .then(response => response.blob()) // Convert the response to a Blob
              .then(blob => {
                // Convert the Blob to Base64
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onload = () => {
                  // Create a temporary anchor element
                  const anchor = document.createElement('a');
                  anchor.href = reader.result; // Set the href to the Base64 data URL
                  anchor.download = 'TERMS OF SERVICE.pdf'; // Set the filename for download
                  anchor.click(); // Trigger the download
                };
              }).catch(error => console.error('Error fetching the file:', error));
              notify("Downloading The Terms of Service Document. Kindly check your downloads...", 'success', 10000);
            onClosePopup();
          }}
        />
      </div>
    </div>
  );
}

export default TermsOfService;
